
// ↓ 使输入框只能输入数字（实现1）前置预防手段
// 示例： @keypress="onlyNumberPress"
export const onlyNumberPress = ($event) => {
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    // console.log("按下了 -->", keyCode); 
    if (
        (keyCode >= 48 && keyCode <= 57)  // 输入数字 0-9，立即放行！
        ||
        (
            $event.target.inputMode === 'numeric' 
            ? false // 整数模式 = false（不放行，拦截所有输入）
            : keyCode == 46 // 非整数模式，输入小数点，也放行 
        )
    ) {
        return; // 在此放行 ❤️❤️❤️ 
    }
    $event.preventDefault();
};


// ↓ 使输入框只能输入数字（实现2）前置预防手段
// ↓ 用法： @keypress="onlyNumberPress" 
export function onlyNumberPress02(ev){
    // console.log("按键:", ev.code);
    const aKeys = [
        'KeyE',  // 禁止 e E
        'NumpadSubtract', 'Minus',  // 禁止 - 
        'NumpadAdd', 'Equal',  // 禁止 + 
    ];
    if (ev.target.inputMode === 'numeric'){
        aKeys.push('Period', 'NumpadDecimal');
    }
    if (aKeys.includes(ev.code)) {
        ev.preventDefault();
        return false;
    }
}


// ↓ 使输入框只能输入数字，后置修正手段  
// ↓ 用法： @input="onlyNumberChange"
export const onlyNumberChange = (ev) => {
    const oInput = ev.target;
    if ([null, void 0, 'NaN', ''].includes(oInput.value)){
        oInput.value = '';
        return;
    }
    // console.log('oInput.value', oInput.value); 
    let sNumber = String(oInput.value);
    const maxLength = oInput.maxLength || sNumber.length;
    const reg = (
        oInput.inputMode === 'numeric'
        ? /\d+/
        : /\d+(?:\.\d*)?|\.\d+|\./ /*详见下方测试用例*/ 
    );
    let [sMath=''] = sNumber.match(reg) || [];
    sNumber = sMath.slice(0, maxLength);
    oInput.value = sNumber; 
};


// 测试用例 
if (import.meta.dev && 0){
    [
        '0',
        '123',
        '.',
        '.0',
        '.00',
        '.1',
        '1.0',
        '1.00',
        '0.1',
        '1.10',
        '1..10',
        '12.',
        'a1.2b',
        '1.2.3',
        'a.b.c',
        'aab.b.1.4',
    ].forEach(cur=>{
        const regex = /\d+(?:\.\d*)?|\.\d+|\./;
        console.log(cur, '👉', cur.match(regex)?.[0])
    })
}
